import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import utc from 'dayjs/plugin/utc';
import { getEventModalShownDatesFromLS } from './eventModalsLS';

dayjs.extend(isToday);
dayjs.extend(utc);

const modalDates = [
  '2025-04-07 07:00:00.000+00:00',
  '2025-04-10 00:00:00.000+00:00',
  '2025-04-13 00:00:00.000+00:00',
  '2025-04-16 00:00:00.000+00:00'
];

export const isShowModalEvent = () => {
  const currentDateObject = modalDates.find(
    (date) => dayjs(date).utc().isToday() && dayjs().utc().isAfter(date, 'second')
  );

  const fullDate = dayjs(currentDateObject).toString();

  const datesFromLs = getEventModalShownDatesFromLS();

  const shouldShowModal = Boolean(currentDateObject) && !datesFromLs.includes(fullDate);

  return {
    shouldShowModal,
    fullDate,
    day: dayjs(currentDateObject).utc().date()
  };
};

const showEvent = (startDateParam: string, endDateParam: string) => {
  const startDate = new Date(startDateParam);
  const endDate = new Date(endDateParam);
  const currentDate = new Date();

  return currentDate >= startDate && currentDate <= endDate;
};

export const isShowEventShop = () => {
  const startDate = '2025-12-15T00:00:01Z';
  const endDate = '2026-01-05T23:59:59Z';
  return showEvent(startDate, endDate);
};

export const datesForGames: Record<number, 'main' | 'catch' | 'wheel'> = {
  3: 'main',
  4: 'wheel',
  5: 'main',
  6: 'main',
  7: 'main',
  8: 'catch',
  9: 'catch',
  10: 'main',
  11: 'wheel',
  12: 'wheel',
  13: 'main',
  14: 'catch',
  15: 'catch',
  16: 'main',
  17: 'wheel',
  18: 'wheel',
  19: 'catch',
  20: 'catch',
  21: 'main'
};

/* valentine event */
export const EVENT_TITLE = 'King’s Day';
export const EVENT_NAME = 'kings_day';

export const PRAGMATIC_EVENT = 'christmas_pragmatic';

/* pragmatic event - удалить 01.01.2026*/
export const isPragmaticEventDates = () => {
  const startDate = '2025-12-01T00:00:01Z';
  const endDate = '2025-12-31T23:59:59Z';
  return showEvent(startDate, endDate);
};
